export default __webpack_public_path__ + "static/media/white-configure-data-symbols-icon.b1cdae65.svg";